
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'BannerAppPromotion',
    components: {
        Icon
    },
    data () {
        return {
            showBanner: null,
            storageKey: 'hideBannerReportsPromotion2025H1'
        }
    },
    mounted () {
        this.showBanner = !(this.$helpers.getLocale() !== 'ar' || localStorage.getItem(this.storageKey))
    },
    methods: {
        closeBanner () {
            this.showBanner = false
            localStorage.setItem(this.storageKey, true)
        }
    }
}
